<template>
  <div class="activityBanner">
    <div class="container">
      <div class="banner-img">
        <img src="@/assets/img/store/banner.png" />
        <!--  style="object-fit: cover;height: 450px" -->
      </div>
      <div class="container">
        <div class="body-info menu-list">
          <dl class="menu-item">
            <dt class="item-top">
              <img src="@/assets/img/store/one_03.png"
                   @click="handleClick('spareRequirementsList')" />
            </dt>
            <dd class="item-name"
                @click="handleClick('spareRequirementsList')">备件需求</dd>
          </dl>
          <dl class="item-line"></dl>
          <dl class="menu-item">
            <dt class="item-top">
              <img src="@/assets/img/store/thr_03.png"
                   @click="handleClick('sparePartsLibrary')" />
            </dt>
            <dd class="item-name"
                @click="handleClick('sparePartsLibrary')">备件库查询</dd>
          </dl>
          <dl class="item-line"></dl>
          <dl class="menu-item">
            <dt class="item-top">
              <img src="@/assets/img/store/four_03.png"
                   @click="handleClick('spareGetList')" />
            </dt>
            <dd class="item-name"
                @click="handleClick('spareGetList')">备件领用</dd>
          </dl>
          <dl class="item-line"></dl>
          <dl class="menu-item">
            <dt class="item-top">
              <img src="@/assets/img/store/two_03.png"
                   @click="handleClick('spareStatementList')" />
            </dt>
            <dd class="item-name"
                @click="handleClick('spareStatementList')">我的对账单</dd>
          </dl>
        </div>
        <div>
          <div class="floor-one">
            <div class="floor-top">
              <h2 class="floor-one-left">设备管理</h2>
              <!-- <div class="floor-one-right">更多</div> -->
            </div>
            <el-row>
              <el-col :span="12" class="col_item">
                <div class="col_img flex-shrink">
                  <img class="col_img" src="https://supconoss.oss-cn-hangzhou.aliyuncs.com/spareStatementDest/rBAAv11OWaeAF5_-AAK2tM501dc441.jpg" />
                </div>
                <div class="flex-grow col_content">
                  <div>
                    <h3>设备维护管理</h3>
                    <p>设备维护管理</p>
                  </div>
                  <div class="detail_but"
                       @click="handleDetail('1')">
                    查看详情
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="col_item">
                <div class="col_img flex-shrink">
                  <img class="col_img" src="https://supconoss.oss-cn-hangzhou.aliyuncs.com/spareStatementDest/rBAAv11OWfaAIhI5AAON3BZRyB4723.jpg" />
                </div>
                <div class="flex-grow col_content">
                  <div>
                    <h3>动设备状态监测与设备诊断</h3>
                    <p>动设备状态监测与设备诊断</p>
                  </div>
                  <div class="detail_but"
                       @click="handleDetail('2')">
                    查看详情
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="floor-one">
            <div class="floor-top">
              <h2 class="floor-one-left">维修检测服务</h2>
            </div>
            <el-row>
              <el-col :span="12" class="col_item">
                <div class="col_img flex-shrink">
                  <img class="col_img" src="https://supconoss.oss-cn-hangzhou.aliyuncs.com/spareStatementDest/rBAAv16GnYmAIiAyAACjo-Lp2Vc197.png" />
                </div>
                <div class="flex-grow col_content">
                  <div>
                    <h3>备件服务</h3>
                    <p>中控保修服务产品是在超出基本保修期后仍可以享受原保修期内相关权益的服务，即延长质保期。</p>
                  </div>
                  <div class="detail_but"
                       @click="handleDetail('3')">
                    查看详情
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="col_item">
                <div class="col_img flex-shrink">
                  <img class="col_img" src="https://devzk.oss-cn-hangzhou.aliyuncs.com/thirdToForth/1614422256087/rBAAv1zecqWAIUwzAAJdqnQy2Es797.jpg" />
                </div>
                <div class="flex-grow col_content">
                  <div>
                    <h3>驻厂维保</h3>
                    <p>驻厂维保主要针对DCS、PLC以及SIS等流程工业控制系统，由专业维保服务工程师常驻于用户现场，提供7*24小时不间断的设备巡检、日常维护保养、故障处理、备件管理、设备报表与分析等专业系统维护服务。</p>
                  </div>
                  <div class="detail_but"
                       @click="handleDetail('4')">
                    查看详情
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer"></span>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {}
  },
  mounted () {
    // this.getUserInfo()
    // this.getInfo()
  },
  methods: {
    handleClick (name) {
      if (getAccessToken() && name) {
        this.$router.push({ name: name })
      } else {
        this.$router.push({
          name: 'login'
        })
      }
    },
    handleDetail (str) {
      if (str === '1') {
        let params = {
          title: '设备管理',
          key: '设备维护管理',
          id: 116
        }
        this.$router.push({ name: 'planContent', query: params })
      } else if (str === '2') {
        let params = {
          title: '设备管理',
          key: '动设备状态监测与故障诊断',
          id: 237
        }
        this.$router.push({ name: 'planContent', query: params })
      } else if (str === '3') {
        // 维修检测服务
        let params = {
          title: '检维修服务',
          key: '备件服务',
          id: 168
        }
        this.$router.push({ name: 'serviceContent', query: params })
      } else {
        // 维修检测服务
        let params = {
          title: '检维修服务',
          key: '驻厂维保',
          id: 183
        }
        this.$router.push({ name: 'serviceContent', query: params })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.floor-one-left{
  margin: 0;
  width: 400px;
  height: 100%;
  color: #262626;
  line-height: 70px;
  font-size: 26px;
  font-weight: normal;
}
.col_item{
  display: flex;
  background-color: #fff;
  padding: 40px 27px;
  .col_img{
    width: 280px;
    height: 180px;
  }
  .col_content{
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h3{
      margin: 0;
      font-weight: normal;
      font-size: 18px;
      color: #333;
    }
    p{
      color: #9b9b9b;
      font-size: 14px;
    }
    .detail_but{
      width: 108px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #eee;
      padding-left: 20px;
      cursor: pointer;
    }
  }
}
.banner-img img {
  width: 100%;
}
.body-info img {
  width: 100%;
}
.body-info h2 {
  font-size: 24px;
  color: #262626;
  margin-top: 0px;
  text-align: center;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 0px;
  // background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.menu-list {
  height: 184px;
  background: #fff;
}
.menu-item {
  width: 296px;
  float: left;
  height: 100%;
  background: #fff;
}
.item-top {
  width: 90px;
  height: 90px;
  margin: 0 auto;
  padding-top: 20px;
  position: relative;
  cursor: pointer;
}
.item-top img {
  height: 45px;
  width: 45px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -16.5px;
  margin-left: -22.5px;
}
.item-name {
  text-align: center;
  cursor: pointer;
  margin: 0;
}
.item-line {
  width: 2px;
  height: 55px;
  margin: 0 auto;
  background: #eeeeee;
  float: left;
  margin-top: 38px;
}
</style>
